import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ReduxRouter } from '@lagunovsky/redux-react-router'
import { NotieProvider } from 'react-notie';
import configureStore from './store';

import './index.sass';
import App from './containers/App';

const createHistory = require('history').createBrowserHistory;
const history = createHistory();

const store = configureStore({}, history);
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
      <ReduxRouter location={history.location} history={history} store={store}>
        <NotieProvider>
          <App />
        </NotieProvider>
      </ReduxRouter>
  </Provider>
);

